import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { UserEvent } from './user-event.model';

export class AnomalieRondeEvent extends UserEvent {
  public static readonly NAME = 'ANOMALIE_RONDE';

  constructor(
    public texte: string | undefined,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates,
    public signature?: string,
    public idZone?: string,
    public siteId?: string,
    public tourneeId?: string,
    public site?: INommable,
    public avecZone = false
  ) {
    super(AnomalieRondeEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieRondeEvent): AnomalieRondeEvent {
    return new AnomalieRondeEvent(
      obj.texte,
      obj.photos ? [...obj.photos] : [],
      dayjs(obj.instant),
      obj.coordinates,
      obj.signature,
      obj.idZone,
      obj.siteId,
      obj.tourneeId,
      obj.site,
      obj.avecZone
    );
  }
}
